import { MenuItem } from "@mui/material";
import { OrganizationProductType, Product } from "generated/graphql";
import { Link } from "react-router-dom";
import { getRoute } from "utils/routing";

export default function UpdateProductMenuItem({
  closeMenu,
  id,
  productTypeId,
}: {
  closeMenu: () => void;
  id: Product["id"];
  productTypeId: OrganizationProductType["id"];
}) {
  return (
    <MenuItem
      component={Link}
      onClick={closeMenu}
      to={getRoute("product-types.products.update", [
        ["productTypeId", productTypeId],
        ["productId", id],
      ])}
    >
      Update Product
    </MenuItem>
  );
}
